import React from 'react';
import { Flex } from 'antd';
import { Button, Tooltip } from '@bettercomp/ui-components';
import { CheckOutlined } from '@ant-design/icons';
import type { NotificationOut } from 'service/notificationsService';
import { formatDate, YEAR_DATE_FORMAT } from 'utils/date';
import cn from './NotificationItem.module.scss';

type Props = {
  notification: NotificationOut;
  onMarkRead?: (id: string) => void;
  onMarkUnread?: (id: string) => void;
};

export function NotificationItem({ notification, onMarkRead, onMarkUnread }: Props) {
  const isUnread = notification.read_at === null;

  return (
    <Flex
      align="center"
      justify="space-between"
      gap={8}
      className={cn.item}
      data-testid="notification-item"
    >
      <Flex vertical gap={2} flex={1}>
        <span className={cn.type}>{notification.type}</span>
        <span className={cn.date}>
          {formatDate(notification.created_at, YEAR_DATE_FORMAT)}
        </span>
      </Flex>
      {isUnread ? (
        <Tooltip title="Mark as read">
          <Button
            shape="circle"
            variant='outlined'
            color='primary'
            icon={<CheckOutlined/>}
            size='small'
            onClick={() => onMarkRead?.(notification.id)}
            data-testid="unread-indicator"
          />
        </Tooltip>
      ) : (
        <Tooltip title="Mark as unread">
          <Button
            shape="circle"
            variant='filled'
            color='default'
            icon={<CheckOutlined/>}
            size='small'
            onClick={() => onMarkUnread?.(notification.id)}
            data-testid="read-indicator"
          />
        </Tooltip>
      )}
    </Flex>
  );
}
